export enum EStorageKeys {
  CURRENT_EVENT = 'currentEvent',
  CURRENT_USER = 'currentUser',
  ACCESS_TOKEN = 'accessToken',
  ID_TOKEN = 'idToken',
  REFRESH_TOKEN = 'refreshToken',
  ACTIVE_CONVERSATION = 'activeConversation',
  CONCERT_SEARCH_FILTER = 'concertSearchFilter',
}
